import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { interval } from 'rxjs';
import { BasicMachineFunctionsService } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { GlobalService } from 'src/app/services/helper/global-helper';
import { IdleTimerService } from 'src/app/services/helper/idleTimer/idle-timer.service';



interface machineConfig {
  serialNumber: string;
  imei: string;
  engineType: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public imei: any;
  public machineConfigs: machineConfig[] = [];
  public myControl = new FormControl('');
  private currentSerialNumber: string = "";
  public valid: boolean = false;
  public connectionAttempt: boolean = false;
  public error: boolean = false;
  public error_mess: string = '';
  public userName = '';
  private keepSessionAlive: any;
  private connected: boolean = false;
  private subscription: any;
  public searching: boolean = false;
  dialogRef!: MatDialogRef<HomeDialogComponent>;

  constructor(public gatewayService: GatewayConnectionService, public machineService: BasicMachineFunctionsService,  private router: Router, private global: GlobalService, private translate: TranslateService, public dialog: MatDialog, private idleService: IdleTimerService){
    this.global.variables.subscribe({
      next: newValue => { 
        this.connectionAttempt = newValue.attempt;
        this.error = newValue.error;
        this.error_mess = newValue.message;
        this.connected = newValue.connected;
      }
    });
    this.global.user.subscribe({
      next: newValue => {
        this.userName = newValue.name;
      }
    });
  }

  ngOnInit() {
    this.myControl.valueChanges.subscribe(value => this.handleChange(value!));
    this.gatewayService.registerUser().subscribe(() => {
      this.keepSessionAlive = interval(90000).subscribe(()=> {
        this.gatewayService.checkBackendAlive().subscribe();
      });
    });
  }

  public handleChange(value: string){
    if(this.currentSerialNumber != value){
      if(typeof(value) == "string"){
        this.currentSerialNumber = value;
      } else {
        this.currentSerialNumber = "";
      }
      this.searching = true;
      this.subscription?.unsubscribe();
      this.subscription = this.machineService.getExchangeToken().subscribe((res) => {
        let response = JSON.parse(JSON.stringify(res.body));
        this.subscription = this.machineService.getMachine(value, response.access_token).subscribe((resp) => {
          let machine = JSON.parse(JSON.stringify(resp.body));
          if(machine._embedded == undefined){
            let option: machineConfig = {serialNumber: this.translate.instant('HOME.NO_ENTRY'), imei: "none", engineType: ""};
            this.machineConfigs.splice(0);
            this.machineConfigs.push(option);
          } else {
            machine = machine._embedded.items;
            this.machineConfigs.splice(0);
            for(var i = 0; i < machine.length; i++){
              this.machineConfigs.push(machine.at(i));
            }
          }
          this.searching = false;
        });              
      });
    }
    this.checkValidation();
  }

  private checkValidation() {
    for( let i = 0; i < this.machineConfigs.length; i++){
      if(this.currentSerialNumber.toUpperCase() == this.machineConfigs[i].serialNumber){
        this.valid = true;
        break;
      } else {
        this.valid = false;
      }
    }
  }


  public handleConnection(option: any){
    this.searching = false;
    if(option != undefined){
      this.global.variables.next({attempt: true});
      this.dialogRef = this.dialog.open(HomeDialogComponent, {width: '50%', data: {loading: true}, disableClose: true});
      this.dialogRef.componentInstance.machinenr = option.serialNumber.toUpperCase();
      this.dialogRef.componentInstance.loading = false;
      let subscription = this.gatewayService.connectToMachine(option).subscribe({
        next: (resp) => {
        //clearTimeout(timer);
        if(option.eolTestDone === false) {
          this.global.comission.next({enabled: true});
        }
        this.dialogRef.close();
        this.idleService.startWatching();
        this.keepSessionAlive?.unsubscribe();
        this.router.navigate(['/menu']); 
        this.global.machineNumber.next({ number: option.serialNumber, id: option.id, series: option.machineSeries });
        if(option.type.line == 'crane') {
          option.type.line = 'green';
        }
        this.global.machineInfos.next({line: option.type.line, name:option.type.name, engine: option.engineType});
        this.global.variables.next({connected: true});
        },
        error: (error) => {
          console.warn(error);
          this.dialogRef.componentInstance.continue = false;
          this.global.errorMessage$.subscribe((message) => {
            this.dialogRef.componentInstance.errorMessage = message;
          });
        }
      });
      // es zeigt fehler message an -- doch timer global? 
      /*let timer = setTimeout(()=>{
        if(!this.connected){
          subscription.unsubscribe();
          this.connectionAttempt = false;
          //console.log('fired timeout home');
          this.global.variables.next({connected: false, attempt: false, error: false, message: ''});
        } else {
          clearTimeout(timer);
        }
      },2000);*/
    }    
  }

  public setSearchValue(event: any){
    let option;
    for( let i = 0; i < this.machineConfigs.length; i++){
      if(event.target.value == this.machineConfigs[i].serialNumber){
        option = this.machineConfigs[i];
      }
    }
    this.handleConnection(option);
  }

  public startConnection() {
    let option;
    for( let i = 0; i < this.machineConfigs.length; i++){
      if(this.currentSerialNumber.toUpperCase() == this.machineConfigs[i].serialNumber){
        option = this.machineConfigs[i];
      }
    }
    this.handleConnection(option);
  }

}


//Dialog
@Component({
  selector: 'home-dialog',
  templateUrl: './../head/direct-connection/direct-connection-dialog.html',
  styleUrls: ['./../head/direct-connection/direct-connection-dialog.scss']
})

export class HomeDialogComponent {

  loading: boolean;
  machinenr = '';
  continue: boolean = true;
  errorMessage: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private dialogRef: MatDialogRef<HomeDialogComponent>){
    this.loading = data.loading;
  }

  toMachineSelection() {
    this.dialogRef.close();
    this.router.navigate(['/']); 
  }
}